import React from 'react';

export default {
  fields: [
    {
      type: 'text',
      name: 'title',
      props: {
        required: true,
        label: <p><i className='asterisk icon inline' />Prize title</p>
      }
    },
    {
      type: 'radio',
      name: 'lang',
      props: {
        label: <p>Which site?</p>,
        options: [
          {key: 'en-US', text: 'Dailybreak', value: 'en-US'},
          {key: 'es-LA', text: 'El Dailybreak', value: 'es-LA'},
          {key: 'en-GB', text: 'Dailybreak UK', value: 'en-GB'}
        ]
      }
    },
    {
      type: 'radio',
      name: 'prizeType',
      props: {
        label: <p>What kind of prize?</p>,
        options: [
          {key: 'raffle', text: 'Editorial Sweeps', value: 'RAFFLE'},
          {key: 'challenge', text: 'Sponsored Prizing', value: 'CHALLENGE'}
        ]
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/components/prizes/createPrizeFormConfig.js